// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-pages-Library-Tax-TaxAssignToItemModal-Search-__SearchForm___2wJQh","search-select":"app-pages-Library-Tax-TaxAssignToItemModal-Search-__SearchForm___sflcH"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Library/Tax/TaxAssignToItemModal/Search/SearchForm.css
// module id = 2196
// module chunks = 0